import { RowCityDto } from "@/dtos";
import { City } from "@/entities";

export const formatRowCityDto = (cities: City[]) => {
    return cities.map(x => {
        const row: RowCityDto = {
            ...x,
            country_label: x.country.name,
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}